export class Pagination {
  static countPrePageDefault = 10;
  constructor(public totalPages: number,
              public curPage: number,
              public countPrePage: number) {
  }

  static createNew(): Pagination {
    return new Pagination(1, 1, Pagination.countPrePageDefault);
  }
}
